
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 188 188"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 49.062l3.887-1.99a192.104 192.104 0 0177.941-20.854L90.19 26l12.057 55.844c4.699 21.77-8.528 43.396-30.07 49.16-21.543 5.764-43.826-6.36-50.657-27.56L4 49.062z","fill":"none","stroke-width":"6"}}),_c('path',{attrs:{"d":"M75.265 80.961C79.872 79.728 82.606 75 81.371 70.4L64.69 74.864c1.234 4.6 5.969 7.33 10.575 6.097zm-31.51 8.432c4.607-1.233 7.34-5.962 6.106-10.562l-16.682 4.464c1.234 4.6 5.97 7.33 10.576 6.098z"}}),_c('path',{attrs:{"d":"M79.272 108.11c-1.329-4.954-7.502-7.607-13.786-5.925-6.285 1.681-10.302 7.06-8.972 12.014","fill":"none","stroke-width":"6"}}),_c('path',{attrs:{"d":"M97.81 55.564l4.363.217a192.105 192.105 0 0177.94 20.855l3.887 1.99-17.52 54.381c-6.83 21.202-29.114 33.325-50.656 27.56-21.543-5.763-34.77-27.39-30.07-49.16L97.81 55.564z","data-stroke-colored":"true","stroke-width":"6","data-fill-bg":"true"}}),_c('path',{attrs:{"d":"M122.846 102.931c1.234-4.6-1.5-9.328-6.106-10.56-4.606-1.234-9.341 1.496-10.576 6.097m48.193 12.894c1.234-4.6-1.5-9.328-6.106-10.56-4.607-1.233-9.342 1.497-10.576 6.097m-27.955 15.334c-1.783 6.645 3.41 13.808 11.6 15.999 8.19 2.191 16.274-1.419 18.057-8.064","data-stroke-colored":"true","fill":"none","stroke-width":"6"}})])
          )
        }
      }
    